import { isInteger } from 'lodash';
import React, { useEffect, useState } from 'react';
import ReorderSectionsDialogView from '../view/ReorderSectionsDialogView';
import { REORDER_SECTIONS } from '../../../store/modules/state/formBuilder';

function arraymove(arr, fromIndex, toIndex) {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}

const ReorderSectionsDialogEngine = ({
  form,
  isReorderSectionsDialogOpen,
  setIsReorderSectionsDialogOpen,
  autosave
}) => {
  const [sections, setSections] = useState([]);

  const resetSections = () => {
    const allFields = [...form.fields, ...form.adminFields];
    let sectionFields = allFields.filter(
      one => one.uiType === 'section_break' && !one.archived
    );
    sectionFields.sort((a, b) => a.position - b.position);
    let idPositionPairs = sectionFields.map(one => {
      return {
        internalId: one.internalId,
        position: one.position
      };
    });

    idPositionPairs.sort((a, b) => a.position - b.position);

    const sortedSectionIds = idPositionPairs.map(one => one.internalId);

    const sectionSizes = [];
    let currentSectionSize = 0;
    let inASection = false;
    let fieldPositions = allFields.map(one => {
      return {
        internalId: one.internalId,
        position: one.position,
        uiType: one.uiType,
        isSubField: one.lookupInfo && one.lookupInfo.subFieldInfo ? true : false
      };
    });
    fieldPositions.sort((a, b) => a.position - b.position);
    fieldPositions = fieldPositions.filter(
      one => !one.archived && !one.isSubField
    );
    fieldPositions.forEach(one => {
      if (one.uiType === 'section_break') {
        if (inASection) {
          sectionSizes.push(currentSectionSize);
          currentSectionSize = 0;
        }
        inASection = true;
      } else {
        if (inASection) {
          currentSectionSize++;
        }
      }
    });
    if (inASection) {
      sectionSizes.push(currentSectionSize);
    }

    const allSections = sectionFields.map((one, k) => {
      return {
        title: one.title,
        index: sortedSectionIds.indexOf(one.internalId),
        internalId: one.internalId,
        sectionSize: sectionSizes[k] || 0
      };
    });
    allSections.sort((a, b) => a.index - b.index);
    setSections(allSections);
  };

  useEffect(() => {
    if (isReorderSectionsDialogOpen) {
      resetSections();
    }
  }, [form, isReorderSectionsDialogOpen]);

  const dialogHandleConfirm = () => {
    autosave({
      type: REORDER_SECTIONS,
      payload: {
        newSectionOrder: sections
      }
    });
    setIsReorderSectionsDialogOpen(false);
  };
  const handleClose = () => {
    setIsReorderSectionsDialogOpen(false);
  };
  const onDragEnd = result => {
    const { source, destination } = result;
    const copyOfSections = [...sections];

    if (
      source &&
      destination &&
      isInteger(source.index) &&
      isInteger(destination.index)
    ) {
      arraymove(copyOfSections, source.index, destination.index);
      copyOfSections.forEach((one, k) => {
        one.index = k;
      });
      setSections(copyOfSections);
    }
  };
  const viewProps = {
    dialogHandleConfirm,
    handleClose,
    onDragEnd,
    open: isReorderSectionsDialogOpen,
    sections
  };

  return <ReorderSectionsDialogView {...viewProps} />;
};

export default ReorderSectionsDialogEngine;
